import _ from 'lodash';
import moment from 'moment';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default class FMPRailcarAutocomplete extends PureComponent {
	render() {
		const {
			label,
			value,
			path,
			onChange,
			railcarOptions,
			error,
			helpText,
			md,
			disabled,
			terminalId,
			filterOlderEmptyDates,
		} = this.props;
		// const options = _.filter(railcarOptions, { terminalId });

		const fourDaysAgo = moment().subtract(4, 'days');
		const options = _.filter(railcarOptions, (option) => {
			if (option.terminalId !== terminalId) {
				return false;
			}

			if (filterOlderEmptyDates && !value) {
				if (option.emptyDate && moment(option.emptyDate).isBefore(fourDaysAgo)) {
					return false;
				}
			}
			return true;
		});

		const _onChange = (_event, onChangeValue) => {
			if (_.isEmpty(onChangeValue)) {
				onChange('', path);
				return;
			}
			return onChange(onChangeValue.value, path);
		};

		const selectedOption = _.find(options, { value });
		console.log('VALUE', value);
		const hasError = !!error;
		return (
			<Grid item xs={12} md={md}>
				<FormControl fullWidth={true} error={hasError} disabled={disabled}>
					<Autocomplete
						multiple={false}
						options={options}
						value={selectedOption}
						disableCloseOnSelect
						onChange={_onChange}
						getOptionLabel={(option) => option.display}
						getOptionSelected={(option, value) => {
							if (!value) {
								return null;
							}
							return option.value === value.value;
						}}
						renderOption={(option, { selected }) => (
							<>
								<Checkbox
									size={'small'}
									icon={icon}
									checkedIcon={checkedIcon}
									style={{ marginRight: 8 }}
									checked={selected}
								/>
								<div>
									<div>{option.display}</div>
									<div style={{ fontSize: '70%', color: '#888' }}>
										Supplier: {option.fuelSupplier}
									</div>
									<div style={{ fontSize: '70%', color: '#888' }}>
										Terminal #{option.terminalId}
									</div>
								</div>
							</>
						)}
						renderInput={(params) => (
							<TextField {...params} label={label} placeholder="Type to search" fullWidth />
						)}
					/>
					{hasError && <FormHelperText>{error}</FormHelperText>}
					{helpText && !hasError && <FormHelperText>{helpText}</FormHelperText>}
				</FormControl>
			</Grid>
		);
	}
}

FMPRailcarAutocomplete.propTypes = {
	label: PropTypes.string,
	value: PropTypes.number,
	path: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	error: PropTypes.string,

	railcarOptions: PropTypes.array.isRequired,
	terminalId: PropTypes.number.isRequired,
	md: PropTypes.number,
	helpText: PropTypes.string,
	readOnly: PropTypes.bool,
	multiple: PropTypes.bool,
	disabled: PropTypes.bool,
	filterOlderEmptyDates: PropTypes.bool,
};

FMPRailcarAutocomplete.defaultProps = {
	label: 'Railcar',
	readOnly: false,
	md: 12,
};
